import React from 'react';
import { ThankYouHeader } from '../../molecules/thank-you-header/thank-you-header.molecule';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { ThankYouFooter } from '../../molecules/thank-you-footer/thank-you-footer.molecule';
import { ThankYouCardAtom } from '../../atoms/thank-you-card/thank-you-card.atom';
import { BoletoCard } from '../../organisms/boleto/boleto-card.organism';
import { Sell } from '../../../common/types/venda';
import { Checkout } from '../../../common/types/checkout';

type Props = {
  venda: Sell;
  checkout: Checkout;
};

export const BoletoPage: React.FC<Props> = ({ venda, checkout }) => {
  return (
    <ThankYouContainer
      padding="2rem"
      margin="0 auto"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f7f9fc',
      }}
    >
      <ThankYouHeader />
      <ThankYouContainer
        padding="2rem 0"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ThankYouCardAtom style={{ maxWidth: '500px' }}>
          <BoletoCard venda={venda} checkout={checkout} />
        </ThankYouCardAtom>
      </ThankYouContainer>
      <ThankYouFooter />
    </ThankYouContainer>
  );
};
